import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

type PercentBoxProps = {
  value?: number;
};

export function PercentBox({ value }: PercentBoxProps) {
  if (value === undefined) {
    return null;
  }

  const formattedValue = value.toFixed(2);
  const progressValue = Math.min(100, Math.max(0, value));

  return (
    <Box
      sx={{
        pr: 4,
      }}
    >
      <Stack spacing={1}>
        <LinearProgress aria-valuetext={formattedValue} value={progressValue} variant="determinate" />
        <Typography>{formattedValue}%</Typography>
      </Stack>
    </Box>
  );
}
